import { Upload } from 'antd';
import styled from 'styled-components';

export default styled(Upload)`
	// Add your styles here
`;
